import React from "react";
import HomeHero from "../sections/HomeHero";
import Brands from "../sections/Brands";
import Products from "../sections/ProductsSection";
import Reason from "../sections/Reason";
import AboutUsSection from "../sections/AboutUsSection";
import ServiceSection from "../sections/ServiceSection";
import ContactSection from "../sections/ContactSection";
import Team from "../sections/Team";

const Home = () => {
  return (
    <div>
      <HomeHero />
      <AboutUsSection />
      <Brands />
      <Products />
      <Reason />
      <ServiceSection />
      <Team />
      <ContactSection />
    </div>
  );
};

export default Home;
